<template>
  <tab-button
    :selected="overviewId == currentOverviewId"
    :title="overview.title || defaultTitle"
    @update:title="updateTitle($event)"
    @close="close"
  >
    <template #icon>
      <evaluation-overview-layout-symbol :overview-id="overview.id" />
    </template>

    <template #context-menu="{ startRenaming }">
      <button
        class="context-menu__entry"
        type="button"
        @click="startRenaming()"
      >
        {{ $t("actions.rename") }}
      </button>
      <button
        class="context-menu__entry"
        type="button"
        @click="$emit('open-layouts', $event)"
      >
        {{ $t("labels.layouts") }}
      </button>
      <button class="context-menu__entry" type="button" @click="duplicate()">
        {{ $t("actions.duplicate") }}
      </button>
      <button
        type="button"
        class="context-menu__entry"
        @click="deleteOverview(overview.id)"
      >
        {{ $t("actions.deleteEvaluationOverview") }}
      </button>
    </template>
  </tab-button>
</template>

<script setup lang="ts">
import { computed } from "vue";

import TabButton from "@core/ui/TabButton.vue";
import EvaluationOverviewLayoutSymbol from "./EvaluationOverviewLayoutSymbol.vue";

import { useEvaluationViewStore } from "@editor/views/evaluation/evaluationView.store";
import { useEvaluationOverviewStore } from "@editor/items/evaluation/evaluationOverviews.store";
import type { EvaluationOverviewItem } from "@editor/items/evaluation/evaluationOverviews.store";

const props = defineProps<{
  overviewId: number;
}>();

const emit = defineEmits<{
  (e: "close"): void;
  (e: "create", item: EvaluationOverviewItem): void;
  (e: "open-layouts", event: MouseEvent): void;
}>();

// ====================
// DATA

const overview = computed(() => {
  return useEvaluationOverviewStore().items[props.overviewId];
});
const currentOverviewId = computed(() => {
  const item = useEvaluationViewStore().currentTabItem;
  if (item == null) return null;
  if (item.type != "evaluationOverview") return null;
  return item.id;
});
const defaultTitle = computed(() => {
  return "" + (props.overviewId + 1);
});

// ====================
// METHODS

async function duplicate() {
  const newOverview = await useEvaluationOverviewStore().duplicate(
    props.overviewId
  );

  console.log("created", newOverview);

  emit("create", newOverview);
}

async function deleteOverview(evaluationId: number | null) {
  if (evaluationId == null) return;
  close();

  try {
    return await useEvaluationOverviewStore().delete({ id: evaluationId });
  } catch (error) {
    console.log((error as Error).message);
  }
}

function close() {
  emit("close");
}

function updateTitle(newTitle: string) {
  useEvaluationOverviewStore().update({
    id: props.overviewId,
    title: newTitle
  });
}
</script>
